import ApplicationAdapter from 'lumen/adapters/application';
import { mockCostProfiles } from 'lumen/utils/net-revenue/cost/cost-profiles-mock';
import type { RawProfile } from 'lumen/utils/net-revenue/cost/types';
import { Promise as RsvpPromise } from 'rsvp';

/**
 * MOCK adapter — see cost-profiles-mock.ts. The list resolves from in-memory
 * mock data (through the real serializer, so the mapping layer is exercised as
 * it will be against the live API).
 */
export default class CostSettingProfileAdapter extends ApplicationAdapter {
  query(): RsvpPromise<{ profiles: RawProfile[] }> {
    return RsvpPromise.resolve(mockCostProfiles());
  }
}
